<template>
    <div>
        <el-row>
            <el-col style="text-align: center" v-if="isShow">
                <div >
                    <el-button-group>
                        <el-button @click="dianji('medicalChannel')" :class="{activeClass:typeName === 'medicalChannel'}" v-if="clientObj.showInstitution">医疗机构
                        </el-button>
                        <el-button @click="dianji('retailOutlet')" :class="{activeClass:typeName === 'retailOutlet'}" v-if="clientObj.showStore">零售终端</el-button>
                        <el-button @click="dianji('distribution')" :class="{activeClass:typeName === 'distribution'}" v-if="clientObj.showDistributor">分销客户</el-button>
                    </el-button-group>
                </div>
            </el-col>
        </el-row>
        <div>
            <medicalChannel v-if="typeName === 'medicalChannel'"></medicalChannel>
            <distribution v-if="typeName === 'distribution'"></distribution>
            <retailOutlet v-if="typeName === 'retailOutlet'"></retailOutlet>
        </div>
    </div>

</template>
<script>
    import medicalChannel from "./components/medicalChannel";
    import retailOutlet from "./components/retailOutlet";
    import distribution from "./components/distribution";
    export default {
        data() {
            return {
                value: '',
                checked:false,
                roomChart:'',
                gradeChart:'',
                typeName:'',
                clientObj:{},
                isShow:true
            };
        },
        components:{
            medicalChannel,
            distribution,
            retailOutlet
        },
        mounted() {
        },
        created() {
            this.clientObj=this.$store.getters.getClient
            if(this.clientObj.showInstitution){
                this.typeName = 'medicalChannel'
            }else if(!this.clientObj.showInstitution && this.clientObj.showStore){
                this.typeName = 'retailOutlet'
            }else if(!this.clientObj.showInstitution && !this.clientObj.showStore && this.clientObj.showDistributor){
                this.typeName = 'distribution'
            }
            let roleArray = []
            for(let i in this.clientObj){
                if(this.clientObj[i]) roleArray.push(this.clientObj[i])
            }
            if(roleArray.length == 1) this.isShow = false

        },
        methods:{
            dianji(type){
                this.typeName = type
            }
        },
    };
</script>
<style scoped>
    .activeClass{
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }
</style>



// WEBPACK FOOTER //
// src/pages/statement/components/visitCover/index.vue